import { SEOProps } from 'components/custom/SEO/SEO';
import { TeaserRichPreamble } from 'graphql/__generated/sdk';
import { SectionItem } from 'pages/CodeOfConduct/models';
import { CtaContent, HeroBannerContent, ImageContent } from 'utils/models';

export type UspItem = {
  iconName: string;
  title: string;
  description: string;
};

type LinkType = {
  id: string;
  title: string;
};

export type PromotionCardType = 'primary' | 'secondary' | 'quaternary' | undefined;

export type PromotionCardProps = {
  title: string;
  preamble: TeaserRichPreamble | any;
  type: PromotionCardType;
  cta: CtaContent;
};

export type MiniParagraphsProps = {
  title: string;
  paragraphs: { title: string; content: React.ReactNode }[];
};

export type FAQSection = {
  title: string;
  items: SectionItem[];
};

export type AssemblyFlexibleProps = {
  heroBanner?: HeroBannerContent;
  showBreadcrumbs: boolean;
  socialMediaShare: boolean;
  contentSection?: any[];
  anchorTabs?: Array<LinkType>;
  seoMetadata?: SEOProps;
};

export enum COMPONENT_TYPE_ENUM {
  TEASER = 'Teaser',
  USP_ENTITY_WRAPPER = 'UspEntityWrapper',
  TEASER_WRAPPER = 'TeaserWrapper',
  FAQ_SECTION = 'FaqSection',
  RICHTEXT_CONTAINER = 'RichtextContainer',
  IMAGE = 'Image',
}

export enum FAQ_TYPE_ENUM {
  MINI_PARAGRAPHS = 'Mini-paragraphs',
  ACCORDION = 'Accordion',
  COMPACT_ACCORDION = 'Compact-accordion',
  PURPLE_CARDS = 'Purple-cards',
}

export enum CARD_TYPE_ENUM {
  LARGE_PURPLE = 'Large-purple',
  SMALL_WHITE = 'Small-white',
  SMALL_PURPLE = 'Small-purple',
  MEDIUM_WHITE_BORDERLESS = 'Medium-white-borderless',
  MEDIUM_WHITE = 'Medium-white',
  LARGE_BASE_CARDS = 'Large-base-cards',
}

export enum TEASER_VARIANT_ENUM {
  PROMOTION_CARD = 'Promotion-card',
}

export type TeaserContent = {
  type: COMPONENT_TYPE_ENUM.TEASER;
  variant: string | null;
  title: string;
  body: any;
  image: ImageContent;
  url: string;
  videoUrl?: string | null;
  cta: {
    text: string;
    url: string;
  };
};

type UspEntityWrapperContent = {
  type: COMPONENT_TYPE_ENUM.USP_ENTITY_WRAPPER;
  title: string;
  isTitleCentered: boolean;
  preamble: string | null;
  uspList: {
    iconName: string;
    title: string;
    description: string;
  }[];
  backgroundColor: string | null;
  cta?: {
    text: string;
    url: string;
  };
};

type TeaserWrapperContent = {
  type: COMPONENT_TYPE_ENUM.TEASER_WRAPPER;
  title: string | null;
  titleCentered: boolean;
  preamble: string | null;
  cardType: string | null;
  isCarousel: boolean;
  items: TeaserContent[];
  backgroundColor: string | null;
  cta?: any;
};

type FaqSectionContent = {
  type: COMPONENT_TYPE_ENUM.FAQ_SECTION;
  faqType: FAQ_TYPE_ENUM;
  title: string;
  items: any[];
  backgroundColor: string | null;
  cta?: {
    text: string;
    url: string;
  };
};

type RichTextContainerContent = {
  type: COMPONENT_TYPE_ENUM.RICHTEXT_CONTAINER;
  richtextContainerId: string;
  disableAnchorTabs: boolean;
  body: {
    content: any;
    links: any;
  };
  reverseOrder: boolean;
  sideSection?: {
    title: string;
    preamble: string;
    cta: any;
  };
};

export type GenerateContentSectionReturnType =
  | TeaserContent
  | UspEntityWrapperContent
  | TeaserWrapperContent
  | FaqSectionContent
  | RichTextContainerContent
  | any
  | undefined;
